// extracted by mini-css-extract-plugin
export var label = "_a6-1";
export var reminder = "_a6-0";